import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ui-card',
  styleUrl: './card.scss',
  templateUrl: './card.html',
})
export class CardComponent {
  /** Titre de la carte. */
  readonly title = input('');

  /** Sous-titre de la carte. */
  readonly subtitle = input('');

  /** Ajoute une ombre portée à la carte. */
  readonly elevated = input(false);

  /** Ajoute un effet de survol cliquable. */
  readonly interactive = input(false);

  /** Applique le padding interne au corps de la carte. */
  readonly padding = input(true);
}
